import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import CloseButton from '../../components/Buttons/CloseButton/index.js';
import BasePage from '../../baseClasses/BasePage';
import Home from '../../containers/Home';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ImageUploader from '../../components/ImageUploader';
import WizardView from '../../components/WizardView';
import PhotoCropperPopup from '../../components/PhotoCropperPopup';
import userService from '../../services/userService.js';
import UserIcon from '../../assets/images/user-img.png';
import dataModel from '../../models/DataModel';
import DataSource from '../../dao/DataSource/DataSource';

import './UserProfile.scss';
import Input from '../../components/Input/index.js';

// TODO: swap this out for the new <MobileUserProfile> component

// Change Tasks to the appropriate name
class UserProfile extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      edited: false,
      user: Object.assign({}, this.props.currentUser, { password: '', confirmPassword: '', newPassword: '' }),
    };

    this.showCropModal = this.showCropModal.bind(this);
    this.handleImageRemove = this.handleImageRemove.bind(this);
  }

  handleUserRetrieved(user, action, acData, fetchedData) {
    if (user) {
      this.setState({ user });
      if (action == 'setPassword') {
        this.setState({
          edited: false,
          user: Object.assign({}, user, { password: '', confirmPassword: '', newPassword: '' }),
        });
        this.props.dataModel.displayInfoErrorMessage('Password changed', 4000, 1);
      }
      else {
        this.setState({
          edited: false,
          user,
        });
      }
    }
  }

  componentDidMount() {
    this.handleRerouting();
    this.userDataSource = new DataSource('User', this.props.currentUser, { user: { additionalFields: ['profile_image'], role: {}, companies: {} } },
      this.handleUserRetrieved);
    this.userDataSource.get();
  }

  componentWillUnmount() {
    if (this.userDataSource) {
      this.userDataSource.release();
      this.userDataSource = null;
    }
  }

  componentDidUpdate() {
    this.handleRerouting();
  }

  handleRerouting() {
    const currentPath = this.props.history.getCurrentLocation().pathname;
    // don't come here on a refresh...
    if (!this.props.currentUser && currentPath != '/') {
      this.props.history.push({ pathname: '/' });
    }
    if (this.props.needsLogin && !currentPath.includes('/login')) {
      this.props.history.push({ pathname: '/login/' });
    }
  }

  showCropModal(file) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result,
        displayPopup: true,
      });
    };
  }

  handleCropPhoto(file) {
    this.setState({
      file: file,
    });
  }

  handleEndCrop() {
    this.setState({
      displayPopup: false,
      edited: true,
    });
    this.setState(this.handleButtonType(this.state.user));
  }

  handleCancelCrop() {
    this.setState({
      displayPopup: false,
      file: null,
      imagePreviewUrl: '',
    });
  }

  handleFirstNameChange(e) {
    const editedUser = Object.assign({}, this.state.user, { first_name: e.target.value, edited: true });
    this.setState({ user: editedUser, edited: true });
    this.setState(this.handleButtonType(editedUser));
  }
  
  handleLastNameChange(e) {
    const editedUser = Object.assign({}, this.state.user, { last_name: e.target.value, edited: true });
    this.setState({ user: editedUser, edited: true });
    this.setState(this.handleButtonType(editedUser));
  }

  handleEmailUpdate(e) {
    userService.checkEmailAvailability(this.state.editUser.email).then((res) => {
      userService.checkEmailAvailability(this.state.editUser.email).then((res) => {
        if (res.message == 'email already exists') {
          dataModel.showGlobalModal('SYSTEM_POPUP', {
            message: 'A user is already associated with this email: ' + this.state.user.email,
            okButtonText: 'OK',
            width: 320,
            height: 182,
            oneButton: true,
            handleOwnerOk: () => {
              let editedUser = Object.assign({}, this.state.user, { email: this.props.currentUser.email });
              this.setState({ user: editedUser });
            },
          });
        }
      });
    });
  }

  handleEmailChange(e) {
    const editedUser = Object.assign({}, this.state.user, { email: e.target.value, edited: true });
    this.setState({ user: editedUser, edited: true });
    this.setState(this.handleButtonType(editedUser));
    this.savedEmail = e.target.value;
  }

  handleOldPasswordChange(e) {
    const editedUser = Object.assign({}, this.state.user, { password: e.target.value, edited: true });
    this.setState({ user: editedUser, edited: true });
    this.setState(this.handleButtonType(editedUser));    
  }

  handleNewPasswordChange(e) {
    const editedUser = Object.assign({}, this.state.user, { newPassword: e.target.value, edited: true });
    this.setState({ user: editedUser, edited: true });

    let match = false;
    if (editedUser.confirmPassword == editedUser.newPassword) {
      match = true;
    }
    this.passwordsMatch = match;
    this.setState(this.handleButtonType(editedUser));
  }

  handleConfirmPasswordChange(e) {
    const editedUser = Object.assign({}, this.state.user, { confirmPassword: e.target.value, edited: true });
    this.setState({ user: editedUser, edited: true });
    let match = false;
    if (editedUser.confirmPassword == editedUser.newPassword) {
      match = true;
    }
    this.passwordsMatch = match;
    this.setState(this.handleButtonType(editedUser));
  }

  handleUpdateUser() {
    const updateUser = Object.assign({}, this.state.user, { profile_image: this.state.file });
    if (updateUser) {
      if (this.state.checkPassword) {
        if (this.passwordsMatch) {
          userService.checkPassword(updateUser, updateUser.email, updateUser.password).then(response => {
            if (response.data.match) {
              updateUser.password = updateUser.newPassword;
              this.userDataSource.update(updateUser, 'setPassword');
            }
            else {
              this.props.dataModel.displayInfoErrorMessage('Password was incorrect', 4000, 2);
            }
          });
        }
        else {
          this.props.dataModel.displayInfoErrorMessage('New Passwords don\'t match', 4000, 1);
        }
      }
      else {
        this.userDataSource.update(updateUser);
      }
    }
  }

  handleImageRemove(){
    this.setState({
      file: null,
      imagePreviewUrl: '',
    });
    if(this.state.user.profile_image){
      const editedUser = Object.assign({}, this.state.user, { profile_image: null, edited: true });
      this.setState({
        user: editedUser,
        edited: true,
      });
    }
  }

  handleDisplayPopup() {
    const cropperPopupPages = [{
      caption: '',
      contents: <PhotoCropperPopup src={this.state.imagePreviewUrl} onUsePhoto={this.handleCropPhoto} marginTop={-82} />,
    }];
    const cropperWizard = {
      popupId: 'cropPhoto',
      width: 298,
      height: 272,
      hasOkButton: true,
      okText: 'USE PHOTO',
      caption: 'Crop Photo',
      pages: cropperPopupPages,
      handleOwnerDone: this.handleEndCrop,
      handleOwnerCancel: this.handleCancelCrop,
      oneButton: true,
    };
    return <WizardView wizard={cropperWizard} />;
  }

  handleButtonType(editedUser) {
    let buttonClass = 'active';
    let checkPassword = false;
    if (editedUser.newPassword && editedUser.newPassword.length > 0) {
      buttonClass = 'disabled';
      checkPassword = true;
      if (editedUser.newPassword.length >= 8 && editedUser.newPassword == editedUser.confirmPassword) {
        if (editedUser.password && editedUser.password.length >= 8) {
          buttonClass = 'active';
        }
      }
    }
    return {
      buttonClass: buttonClass,
      checkPassword: checkPassword,
    };
  }

  validatePassword(type) {
    let message;
    if (this.state.buttonClass == 'disabled' || !this.passwordsMatch) {
      switch (type) {
      case 'old':
        if (this.state.user.password && this.state.user.password.length < 8) {
          message = <div className="data-validation-message">Password must be 8 characters or longer</div>;
        }
        break;
      case 'new':
        if (this.state.user.newPassword && this.state.user.newPassword.length < 8) {
          message = <div className="data-validation-message">Password must be 8 characters or longer</div>;
        }
        break;
      case 'confirm':
        if (this.state.user.confirmPassword && this.state.user.newPassword && this.state.user.confirmPassword != this.state.user.newPassword) {
          message = <div className="data-validation-message">Passwords must match</div>;
        }
        break;
      default:
        message = null;
      }
    }
    return message;
  } 

  render() {
    if (!this.props.currentUser || !this.props.currentCompany || !this.props.permissions) {
      return <Home type="user" />;
    }
    this.setWhiteLabels(this.props.currentCompany);
    if (this.originalUser != this.props.currentUser) {
      this.state.user = this.originalUser = this.props.currentUser;
      this.password = '';
    }

    let profileUrl = UserIcon;
    let name;

    if (this.state.user) {
      if (this.state.user.profile_image) {
        profileUrl = this.state.user.profile_image;
      }
      name = this.state.user.name ? this.state.user.name.toUpperCase() : (this.state.user.first_name.toUpperCase() + ' ' + this.state.user.last_name.toUpperCase());
    }
    let button;
    if (this.state.edited) {
      if (this.state.buttonClass == 'disabled') {
        button = <div className={'button-save ' + this.state.buttonClass}>SAVE</div>;
      }
      else {
        button = <div className={'button-save ' + this.state.buttonClass} onClick={this.handleUpdateUser}>SAVE</div>;
      }
    }
    let popup;
    if (this.state.displayPopup) {
      popup = this.handleDisplayPopup();
    }
    let oldPasswordMessage = this.validatePassword('old');
    let newPasswordMessage = this.validatePassword('new');
    let confirmPasswordMessage = this.validatePassword('confirm');
    return (

      // Replace with the appropriate HTML
      <div className="main-container">
        <Header currentUser={this.props.currentUser} />
        <div className="user-profile-container" >
        <div className="user-profile-inner-container" >
          <div className='user-profile-pic'>
            <ImageUploader cropFile={this.state.file} file={profileUrl} height={142} width={142} borderRadius="50%" handlePickPhoto={this.showCropModal} />
            <CloseButton 
              className="profile-pic-remove-button"
              left={142}
              width={15}
              height={15}
              top={-142}
              fillColor="#ffffff"
              borderColor="#ffffff"
              hasShadow={false}
              handleClick={this.handleImageRemove} 
            />
          </div>
          <div className="user-name">{name}</div>
          <div className="user-title">{this.state.user.name}</div>
          <hr className="dash" />
          <Input className="user-first-name" placeholder="First Name" type="text" value={this.state.user.first_name || ''} onChange={this.handleFirstNameChange} />
          <Input className="user-last-name" placeholder="Last Name" type="text" value={this.state.user.last_name || ''} onChange={this.handleLastNameChange} />
          <Input className="user-email" placeholder="Email" type="text" value={this.state.user.email || ''} onChange={this.handleEmailChange} />
          <Input className="old-password" placeholder="Password" type="password" value={this.state.user.password || ''} onChange={this.handleOldPasswordChange} />
          {oldPasswordMessage}
          <Input className="new-password" placeholder="New Password" type="password" value={this.state.user.newPassword || ''} onChange={this.handleNewPasswordChange} />
          {newPasswordMessage}
          <Input className="confirm-password" placeholder="Confirm Password" type="password" value={this.state.user.confirmPassword || ''} onChange={this.handleConfirmPasswordChange} />
          {confirmPasswordMessage}
          {button}
          </div>
          </div>
        {popup}
        <Footer />
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    permissions: state.new_users.permissions,
    needsLogin: state.main.needsLogin,
    sessionTimeout: state.main ? state.main.sessionTimeout : null,
    needsPartialLogin: state.main ? state.main.needsPartialLogin : null,
  };

};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };

};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserProfile));



// WEBPACK FOOTER //
// ./src/containers/UserProfile/index.js